import { render, staticRenderFns } from "./ModifyPromotionText.vue?vue&type=template&id=3634fdac&"
import script from "./ModifyPromotionText.vue?vue&type=script&lang=ts&"
export * from "./ModifyPromotionText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports